@switch (gridType) {
    @case (1) {
        <div class="title-l-b ttu is-flex content-center pt-64 pb-40" [ngStyle]="{ color: (templateConfiguration$ | async)?.styles['fontColor'] }">
            {{ getNewCollectionTitle$ | async | translate }}
        </div>

        <app-grid-studio
            [category]="category"
            [isCategoryNew]="isCategoryNew"
            [gridElements]="gridElementsFiltered$ | async"
            [pageGridElements]="pageGridElements$ | async"
            [place]="'PRODUCT_NEW_COLLECTION'"
            (loadNextPageEvent)="onScrollGridStudio()"
        ></app-grid-studio>
    }

    @case (2) {
        <div class="title-l-b ttu is-flex content-center pt-64 pb-48" [ngStyle]="{ color: (templateConfiguration$ | async)?.styles['fontColor'] }">
            {{ getNewCollectionTitle$ | async | translate }}
        </div>

        <app-grid-default-2
            [productIds]="defaultPageIdsFiltered$ | async"
            [category]="category"
            [isCategoryNew]="isCategoryNew"
            [place]="'PRODUCT_NEW_COLLECTION'"
            (loadNextPageEvent)="onScrollGridDefault()"
        ></app-grid-default-2>
    }

    @case (3) {
        <div class="title-l-b ttu is-flex content-center pt-64 pb-48" [ngStyle]="{ color: (templateConfiguration$ | async)?.styles['fontColor'] }">
            {{ getNewCollectionTitle$ | async | translate }}
        </div>

        <app-grid-default-3
            [productIds]="defaultPageIdsFiltered$ | async"
            [category]="category"
            [isCategoryNew]="isCategoryNew"
            [place]="'PRODUCT_NEW_COLLECTION'"
            (loadNextPageEvent)="onScrollGridDefault()"
        ></app-grid-default-3>
    }
}
